import React from "react";

import LogoProyecto from "./../../UI/Logos/logo-proyecto.svg";

interface Props {
  isLoading: boolean;
  isWelcome: boolean;
  handleHideWelcome: any;
}

interface State {}

class WelcomeScreen extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        className={
          this.props.isLoading || this.props.isWelcome
            ? "welcome-container fade-out"
            : "welcome-container fade-in"
        }
      >
        <div className="logo-proyecto-container">
          <img src={LogoProyecto} />
        </div>
        <div className="text-container">
          <div className="legal-text">
            Las imágenes aquí contenidas y piezas publicitarias del proyecto,
            complementan y actualizan la información presentada acercándola a la
            realidad. En consecuencia, pueden presentar, en cualquier momento,
            variaciones pues contienen elementos de apreciación estética que son
            interpretación del diseñador.
          </div>
        </div>
        <div
          className="btn-ingreso"
          onClick={() => {
            this.props.handleHideWelcome();
          }}
        >
          Ingresar
        </div>
      </div>
    );
  }
}

export default WelcomeScreen;
